import { observableEvent } from '../_utils/observable-event';

export default class UploadAnalytics {
  // TODO: Replace eventTypes and beamrUploadSource with compressionUpload

  static eventTypes(uploadAnalyticsArray) {
    const uploadRaw = 0,
      uploadBeamr = 1,
      uploadFellback = -1,
      // the values of the above don't matter, it's just for the input and output to be comparable
      uploads = uploadAnalyticsArray.map((a) => a.beamr_upload_source),
      tally = uploads.reduce(
        (tally, event) => {
          if (event == uploadRaw) {
            tally['raw']++;
          }
          if (event == uploadBeamr) {
            tally['beamr']++;
          }
          if (event == 'local-compression') {
            tally['local_compression']++;
          }
          if (event == uploadFellback) {
            tally['fellback']++;
            tally['raw']++;
          }

          return tally;
        },
        {
          raw: 0,
          beamr: 0,
          fellback: 0,
          local_compression: 0,
        },
      );

    if (tally.fellback > 0) {
      return `failover beamr: ${tally.beamr} raw: ${tally.raw}`;
    } else if (tally.beamr > 0) {
      return 'beamr';
    } else if (tally.local_compression > 0) {
      return 'local-compression';
    } else {
      return 'raw';
    }
  }

  constructor({
    fileName = null,
    uploadTransactionId = null,
    uploadTimings = {},
    fileUploadSource,
  }) {
    this._transactionId = uploadTransactionId;
    this._timings = uploadTimings;

    this._fileName = fileName;
    this.fileUploadSource = fileUploadSource;
    this._fileData = {
      originalSize: null,
      compressedSize: null,
    };
  }

  setFileSizes(originalSize = null, compressedSize = null) {
    let changed = false;

    if (typeof originalSize !== null) {
      this._fileData.originalSize = originalSize;
      changed = true;
    }

    if (typeof compressedSize !== null) {
      this._fileData.compressedSize = compressedSize;
      changed = true;
    }

    return changed;
  }

  sendObservability() {
    observableEvent.record('photo-upload-beamr-success', {
      compr_elapsed_time_ms: this._timings.compressionDuration(),
      total_elapsed_time_ms: this._timings.completeDuration(),
      original_size: this._fileData.originalSize,
      optimized_size: this._fileData.compressedSize,
      num_threads: window.navigator.hardwareConcurrency,
    });
  }
}
